import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

const CLONE_SELECTOR = '[data-target="team-members.clone"]';
const REMOVE_SELECTOR = '[data-target="team-members.remove"]';
const BUTTONS_SELECTOR = '[data-target="team-members.buttons"]';

class TeamMembersController extends Controller {
  connect() {
    this.maximumTeamMembers = 25;

    this.reindex();
  }

  add() {
    const clone = this.originTarget.cloneNode(true);
    const fields = toArray(clone.querySelectorAll('[name^=team_members]'));

    clone.setAttribute('data-target', 'team-members.clone');

    fields.forEach((field) => {
      if (field.tagName === 'INPUT' && field.type === 'text') {
        field.value = '';
      }
    });

    this.outputTarget.append(clone);
    this.reindex();
  }

  remove({ target }) {
    target.closest(CLONE_SELECTOR).remove();

    this.reindex();
  }

  reindex() {
    let clones = toArray(this.cloneTargets);
    const attributes = ['id', 'for', 'name', 'data-porta-parent'];
    const totalTeamMembers = clones.length + 1;
    const canAddMore = totalTeamMembers < this.maximumTeamMembers;
    const maximumClones = this.maximumTeamMembers - 1;

    clones = clones.filter((clone, index) => {
      if (index >= maximumClones) {
        clone.remove();

        return false;
      }

      return true;
    });

    this.originTarget.querySelector(BUTTONS_SELECTOR).classList[canAddMore && clones.length === 0 ? 'remove' : 'add']('d-none');
    this.originTarget.querySelector(BUTTONS_SELECTOR).classList[canAddMore && clones.length === 0 ? 'add' : 'remove']('d-flex');

    this.countTargets.forEach((count, iteration) => {
      count.innerText = iteration + 1;
    });

    clones.forEach((clone, i) => {
      const fields = toArray(clone.querySelectorAll('[id^=team_members], [for^=team_members], [name^=team_members], [id*=porta-wrapper-team_members], [data-porta-parent*=porta-wrapper-team_members]'));
      const isLast = i === clones.length - 1;

      // Hide plus and min buttons for all clones unless it's the last one
      clone.querySelector(BUTTONS_SELECTOR).classList[canAddMore && isLast ? 'remove' : 'add']('d-none');
      clone.querySelector(BUTTONS_SELECTOR).classList[canAddMore && isLast ? 'add' : 'remove']('d-flex');

      clone.querySelector(REMOVE_SELECTOR)[isLast ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');

      fields.forEach((field) => {
        attributes.forEach((attribute) => {
          const attr = field.getAttribute(attribute);

          if (attr) {
            let value = attr.replace(/team_members\[(\d+)]/, `team_members[${i + 1}]`);

            value = value.replace(/team_members-(\d+)-/, `team_members-${i + 1}-`);

            field.setAttribute(attribute, value);
          }
        });
      });
    });
  }
}

TeamMembersController.targets = ['add', 'remove', 'origin', 'output', 'clone', 'count'];

export default TeamMembersController;
